import { render, staticRenderFns } from "./ProductEditDefault.vue?vue&type=template&id=461f2719"
import script from "./ProductEditDefault.vue?vue&type=script&lang=ts"
export * from "./ProductEditDefault.vue?vue&type=script&lang=ts"
import style0 from "./ProductEditDefault.vue?vue&type=style&index=0&id=461f2719&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports